export type CommonProps = {
  data: any
  search: string
  entity: string
  regionParam: string
  t: { (key: string): string; (arg0: string): string }
  isGlobal?: boolean
  availableEntities: string[][]
  entityIndex: number
}

export function getRegionTitle(entity: string, regionParam: string) {
  if (regionParam === "All") {
    if (entity === "regions") {
      return "Global"
    }
    return "Total"
  }
  if (entity === "regions") {
    return "Global"
  }
  return regionParam
}

export function getCustomTitle(
  key: string,
  search: string,
  data: any,
  t: { (key: string): string; (arg0: string): string },
  entity: string,
  global?: boolean,
) {
  const curYear = new Date().getFullYear()
  const updated = new URLSearchParams(search)

  const year = updated.get("year") || ""
  const scenario = updated.get("scenario") || ""

  if (!!global) {
    return data.total[entity]?.[key]
  }

  if (key === "targetRevenue") {
    return `${curYear} ${t("revenue.target")}`
  }
  if (key === "ytdRevenue") {
    return `${t("revenue.current")} (${year} ${scenario})`
  }

  if (key === "previousScenarioRevenueValue") {
    return `${t(
      "revenue.previous",
    )} (${data?.yearForPreviousScenario} ${data?.previousScenario})`
  }
}
export function getCustomTitleNonGcf(
  key: string,
  search: string,
  data: any,
  t: { (key: string): string; (arg0: string): string },
  entity: string,
  global?: boolean,
) {
  const curYear = new Date().getFullYear()
  const updated = new URLSearchParams(search)

  const scenario = updated.get("scenario") || ""

  if (!!global) {
    return data.total[entity]?.[key]
  }

  if (key === "budRev") {
    return `${curYear} ${t("revenue.bud")}`
  }
  if (key === "currRev") {
    return scenario === "BUD"
      ? `${t(
          "revenue.current",
        )} (${data?.prevActYear} ${data?.prevActScenario})`
      : `${t("revenue.current")} (${data?.year} ${data?.scenario})`
  }

  if (key === "prevRev") {
    return `${t("revenue.previous")} (${data?.prevYear} ${data?.prevScenario})`
  }
}

export function formatData(
  key: string,
  props: CommonProps,
  dataType: string,
  type?: string,
) {
  let obj = {} as any

  const { data, entity, search, t, isGlobal, availableEntities, entityIndex } =
    props

  data.data[entity].map((x: any) => {
    if (!!x.entityName) {
      if (availableEntities[entityIndex].indexOf(x.entityName) === -1) {
        obj[x.entityName as keyof typeof x] = 0
      } else {
        obj[x.entityName as keyof typeof x] = x[key as keyof typeof x]
      }
    }

    return obj
  })

  return dataType === "gcf"
    ? {
        ...obj,
        title: getCustomTitle(key, search, data, t, entity, isGlobal),
      }
    : {
        ...obj,
        title: getCustomTitleNonGcf(
          type === "tbg" ? getTbgNetKeys(key) : key,
          search,
          data,
          t,
          entity,
          isGlobal,
        ),
      }
  // returns an object of type: {LATAM: 99999, APAC: 8888, ... , title: 'Current..'}
}

export function calculateHeight(data: number[]) {
  return data.reduce((accumulator, value) => {
    return accumulator + value
  }, 0)
}

export const getTitles = (d: any) => d.title

export const getTbgNetKeys = (key: string) => {
  switch (key) {
    case "budTbgRev":
      return "budRev"

    case "currTbgRev":
      return "currRev"

    default:
      return "prevRev"
  }
}

export const sumDirection = (
  keys: any[],
  cur: { [x: string]: string | number },
  direction: number,
) =>
  keys.reduce((dailyTotal, k) => {
    const val = cur[k] as any
    if (val * direction > 0) {
      dailyTotal += +cur[k]
    }
    return dailyTotal
  }, 0)
